import React, { FC, useState, useEffect } from 'react'

export const AncientCardHeader: React.FC = ({ children }) => {
    const [title, toolbar] = React.Children.toArray(children)

    return (
        <div className='card-header border-0'>
            <h3 className='card-title'>{title}</h3>
            <div className='card-toolbar'>
                {toolbar}
            </div>
        </div>
    )
}

